export const purchaseOrderListHandlersRef = { current: null };
